
import './styles/_globals.scss';
import ReactDOM from 'react-dom';
import App from './App';
import MainContextProvider from './contexts/MainContextProvider';


ReactDOM.render(
  <MainContextProvider>
    <App />
  </MainContextProvider>,
  document.getElementById('root')
);

